(() => {
  function init(scope) {
    scope.querySelectorAll('[data-drink-guide]').forEach(root => {
      if (root.dataset.ready) return;
      const tabs = [...root.querySelectorAll('[data-drink-tab]')];
      const panels = [...root.querySelectorAll('[data-drink-panel]')];
      if (tabs.length !== panels.length || !tabs.length) return;
      function select(index, focus = false) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].setAttribute('aria-hidden', String(i !== index));
          panels[i].inert = i !== index;
        });
        if (focus) tabs[index].focus();
      }
      root.querySelector('[data-drink-tabs]').setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          const keys = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          select(keys[event.key], true);
        });
      });
      select(0);
      root.dataset.ready = 'true';
      root.querySelector('[data-drink-tabs]').hidden = false;
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
